<template>
  <div class="full-calendar-header">
    <div class="header-left">
      <slot name="header-left"></slot>
    </div>
    <div class="header-center">
      <slot name="header-center"></slot>
    </div>
    <div class="header-right d-flex justify-content-end">
      <t-select v-model="year">
        <t-option v-for="val in years" :key="val" :value="val">{{ val }}年</t-option>
      </t-select>
      <div class="header-right-item">
        <t-select v-if="mode === 'month'" v-model="month">
          <t-option v-for="val in months" :key="val" :value="val">{{ val }}月</t-option>
        </t-select>
      </div>
      <div class="header-right-item">
        <t-radio-group v-model="mode" type="button">
          <t-radio label="月" value="month"></t-radio>
          <t-radio label="年" value="year"></t-radio>
        </t-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import { TSelect, TOption, TRadio, TRadioGroup } from '@/module'

export default {
  name: 'TCalendarHeader',
  components: {
    TSelect, TOption, TRadioGroup, TRadio
  },
  props: {
    date: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      year: this.date.year(),
      month: this.date.month() + 1,
      mode: 'month'
    }
  },
  computed: {
    years() {
      const current = this.date.year()
      let ret = [current]
      for (let i = 1; i < 11; i++) {
        ret.push(current + i)
        ret.unshift(current - i)
      }
      return ret
    },
    months() {
      let ret = []
      for (let i = 1; i < 13; i++) {
        ret.push(i)
      }
      return ret
    }
  },
  watch: {
    year(newVal) {
      this.$emit('change-year', newVal)
    },
    month(newVal) {
      this.$emit('change-month', newVal)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/module/calendar/calendar-header.vue